import React from 'react';
import { User } from 'lucide-react';

const UserAvatar: React.FC = () => {
	return (
		<div className="absolute top-6 left-6 flex items-center gap-2">
			<div className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center">
				<User className="w-6 h-6 text-white" />
			</div>
			<span className="text-gray-800 font-semibold text-sm">SeamlessVisa</span>
		</div>
	);
};

export default UserAvatar;

